<template>
  <div name="videotype">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">影片分類</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">影音</li>
              <li class="breadcrumb-item active">影片分類</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-programme" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-9">
            列表排序方式與頁面「
            <router-link :to="{name:'Morevideo'}" tag="a" target="_blank">影片一覽 — 篩選</router-link>」關聯
          </div>
          <div class="col-sm-3">
            <el-button type="primary" @click="addVideo()">
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i>新增分類
            </el-button>
            <el-button type="info" @click="sortout()">
              <i class="nav-icon fas fa-save fa-sm mr-1"></i>保存當前排序
            </el-button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="videoTypeList"
                  border
                  row-key="id"
                  v-if="isShow"
                  v-loading="mloading"
                >
                  <el-table-column width="40">
                    <template>
                      <i class="fas fa-arrows-alt-v handle"></i>
                    </template>
                  </el-table-column>
                  <el-table-column label="影片分類">
                    <template slot-scope="scope">
                      <span class="typestyle">{{scope.row.sgL_Type_Name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="sgL_Type_NameDesc" label="描述"></el-table-column>
                  <el-table-column prop="moveCount" label="影片數量"></el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="primary" size="mini" @click="editVideoFuc(scope.row.id)">編輯</el-button>
                      <el-popconfirm title="確定刪除嗎？" @onConfirm="DeleteType(scope.row.id)">
                        <el-button size="mini" type="danger" slot="reference">刪除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
      <!-- Modal: 新增/編輯影片分類 -->
      <el-dialog title="新增/編輯影片分類" :close-on-click-modal="false" :visible.sync="editIsShow">
        <el-form :model="editVideo" ref="editVideo" :rules="videoRules" label-width="120px">
          <el-form-item label="影片分類" prop="sgL_Type_Name">
            <el-input v-model="editVideo.sgL_Type_Name"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="editVideo.sgL_Type_NameDesc"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="hidden" v-model="editVideo.id"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editIsShow = false">取消</el-button>
          <el-button type="primary" @click="submitForm('editVideo')">確定</el-button>
        </div>
      </el-dialog>
      <!-- /.modal: 新增/編輯影片分類 -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import Sortable from "../../../node_modules/sortablejs";
import { Message } from "element-ui";
export default {
  name: "videotype",
  data() {
    return {
      mloading: true,
      data: [], //影片类型列表
      editVideo: {
        //编辑添加影片类型实体
        sgL_Type_Name: null,
        sgL_Type_NameDesc: null,
        id: null
      },
      sortList: [],
      isShow: true,
      isUpdate: "",
      editIsShow: false,
      videoRules: {
        sgL_Type_Name: [
          { required: true, message: "請填寫影片分類名稱", triggle: "blur" }
        ]
      }
    };
  },
  created() {
    this.getVideoTypeList();
  },
  mounted() {
    this.rowDrop(); //用于拖拽排序进来时加载
  },
  watch: {
    isUpdate: {
      handler(newval) {
        this.isShow = false;
        this.$nextTick(() => {
          this.isShow = true;
        });
      },
      deep: true
    },
    data(newvalue, oldvalue) {
      if (newvalue.length > 0) {
        this.mloading = false;
      }
    }
  },
  beforeMount() {
    let admin = this.$store.getters.getAdminUser;
    let permission = this.$store.getters.getPermission;
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  methods: {
    //获取数据
    async getVideoTypeList() {
      let param = { Sorting: "1", SkipCount: 0, MaxResultCount: 50 };
      this.$api.VideoApi.GetAdminMovieTypeList(param).then(res => {
        //es6 语法中then里面不能使用this调用组件中的属性，只能使用箭头函数result=>
        if (res.data.success) {
          this.data = res.data.result.items;
          this.$store.dispatch("writeVideoCategory", this.data);
        } else {
          let s = res.data.error.message;
          Message({
            type: "error",
            message: s
          });
        }
        this.mloading = false;
      });
    },
    //添加编辑影片類型
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editVideo.id != null) {
            //修改
            let params = {
              sgL_Type_Name: this.editVideo.sgL_Type_Name,
              sgL_Type_NameDesc: this.editVideo.sgL_Type_NameDesc,
              id: this.editVideo.id
            };
            this.$api.VideoApi.EditAdminVideo(params).then(res => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "修改成功"
                });
              } else {
                Message({
                  type: "error",
                  message: "修改失敗"
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.getVideoTypeList();
            });
          } else {
            //添加
            let params = {
              sgL_Type_Name: this.editVideo.sgL_Type_Name,
              sgL_Type_NameDesc: this.editVideo.sgL_Type_NameDesc
            };
            this.$api.VideoApi.AddAdminVideo(params).then(res => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "添加成功"
                });
              } else {
                Message({
                  type: "error",
                  message: "添加失敗"
                });
              }
              this.editIsShow = false;
              //重新查詢數據
              this.getVideoTypeList();
            });
          }
        }
      });
    },
    //打开新增页面
    addVideo() {
      this.editVideo = this.$options.data().editVideo; //置空表单
      this.editIsShow = true;
    },
    //打开修改影片类型页面
    editVideoFuc(id) {
      let msg = "";
      this.editVideo = this.$options.data().editVideo; //置空表单
      this.editIsShow = true;
      this.GetSingleType(id).then(res => {
        if (res.data.success) {
          let typeModel = res.data.result;
          if (typeModel == null) return;
          //赋值给model
          this.editVideo.sgL_Type_Name = typeModel.sgL_Type_Name;
          this.editVideo.sgL_Type_NameDesc = typeModel.sgL_Type_NameDesc;
          this.editVideo.id = typeModel.id;
        } else {
          Message({
            type: "warning",
            message: "未找到該信息"
          });
        }
      });
    },
    //根据Id获取数据
    async GetSingleType(id) {
      let params = { id: id };
      return this.$api.VideoApi.GetAdminSingleType(params);
    },
    //删除数据
    DeleteType(id) {
      let params = {
        Id: id
      };
      this.$api.VideoApi.DeleteAdminVideoType(params).then(res => {
        if (res.data.success) {
          Message({
            type: "success",
            message: "刪除成功"
          });
        } else {
          Message({
            type: "error",
            message: res.data.error.message
          });
        }
        this.getVideoTypeList();
      });
    },
    //保存排序
    sortout() {
      this.sortList = [];
      this.data.map((item, index) => {
        //拖拽时改变了data数据顺序、所以直接取index就可以取到排序值
        let sort = { id: item.id, sortID: index };
        this.sortList.push(sort);
      });
      this.$api.VideoApi.AdminSort(this.sortList).then(res => {
        if (res.data.success) {
          Message({ type: "success", message: "保存成功" });
        } else {
          Message({ type: "error", message: res.data.error.message });
        }
      });
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.data.splice(oldIndex, 1)[0];
          // if (currRow != null) {
          //   //查找数组中是否已经操作过该条数据
          //   let index = _this.sortList.findIndex(item => {
          //     if (item.id == currRow.id) {
          //       return true;
          //     }
          //   });
          //   if (index > -1) {
          //     //删除已操作过的数据
          //     _this.sortList.splice(index, 1);
          //   }
          //   //赋值添加sort
          //   currRow.sgL_OrderBy = newIndex;
          //   let sort = { id: currRow.id, sortId: currRow.sgL_OrderBy };
          //   _this.sortList.push(sort);
          // }
          _this.data.splice(newIndex, 0, currRow);
        }
      });
    }
  },

  computed: {
    videoTypeList() {
      return this.data;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AdminVideo/VideoType.vue